export const frontEndData = [
    {
        id:1,
        title : 'Html5',
        image:'images/html5.jpg',
    },
    {
        id:2,
        title : 'Css3',
        image: 'images/css.png'
    },
    {
        id:3,
        title : 'JavaScript',
        image: 'images/javascript.png'
    },
    {
        id:4,
        title : 'React',
        image: 'images/react.png'
    },
    {
        id:5,
        title : 'Redux',
        image: 'https://ih1.redbubble.net/image.370541778.7231/st,small,507x507-pad,600x600,f8f8f8.u20.jpg'
    },
    
];

export const backEndData = [
    {
        id:1,
        title : 'Node Js',
        image: 'images/nodejs.jpg'
    },
    {
        id:2,
        title : 'Express Js',
        image: 'images/expressjs.png'
    },
    
];

export const programmingLangData = [
    {
        id:1,
        title : 'JavaScript',
        image: 'images/javascript.png'
    },
    {
        id:2,
        title : 'C',
        image: 'images/c.png'
    },
    {
        id:3,
        title : 'C++',
        image: 'images/c++.jpg'
    },
];

export const dataBaseData = [
    {
        id:1,
        title : 'MongoDb',
        image: 'images/mongo.jpg'
    },
    {
        id:2,
        title : 'My SQL',
        image: 'images/mysql.png'
    },
    
];

export const hostingPlatformData = [
    {
        id:1,
        title : 'Heroku',
        image: 'images/heroku.png'
    },
    {
        id:2,
        title : 'GitHub Pages',
        image: 'images/GitHub-icon.png'
    },
    {
        id:3,
        title : 'Vercel',
        image: 'images/vercel.png'
    },
   
    
];


